import React from "react";
import { StatusBadge } from "utils/ui";

const TableElement = ({ type = "text", value, style }) => {
  const content = {
    text:    <span>{value}</span>,
    boolean: <StatusBadge active={value} />,
    element: value,
  }[type];

  return (
    <td
      style={{
        padding: "0.7rem 1rem",
        fontSize: "0.8rem",
        color: "var(--color-text-primary)",
        borderBottom: "1px solid #F1F5F9",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...style,
      }}
    >
      {content}
    </td>
  );
};

export default TableElement;
